var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Header"),
      _vm._v(" "),
      _c("div", { attrs: { id: "main" } }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-8 offset-md-2" }, [
              _c("h2", [_vm._v("Redefinição de Senha")]),
              _vm._v(" "),
              _c("span", [_vm._v("Informe sua nova senha e confirme.")]),
              _vm._v(" "),
              _vm.showMsg
                ? _c(
                    "div",
                    {
                      staticClass:
                        "alert alert-danger alert-dismissible fade show",
                      attrs: { role: "alert" }
                    },
                    [
                      _vm._v(
                        "\n            " + _vm._s(_vm.msg) + "\n            "
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "close",
                          attrs: {
                            type: "button",
                            "data-dismiss": "alert",
                            "aria-label": "Fechar"
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.hideMsg()
                            }
                          }
                        },
                        [
                          _c("span", { attrs: { "aria-hidden": "true" } }, [
                            _vm._v("×")
                          ])
                        ]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showMsgSuccess
                ? _c(
                    "div",
                    {
                      staticClass:
                        "alert alert-success alert-dismissible fade show",
                      attrs: { role: "alert" }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.msgSuccess) +
                          "\n            "
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "close",
                          attrs: {
                            type: "button",
                            "data-dismiss": "alert",
                            "aria-label": "Fechar"
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.hideMsg()
                            }
                          }
                        },
                        [
                          _c("span", { attrs: { "aria-hidden": "true" } }, [
                            _vm._v("×")
                          ])
                        ]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.passwordRedefined && !_vm.invalidToken
                ? _c("form", { staticClass: "signin-form" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "emailInput" } }, [
                        _vm._v("E-mail")
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.username,
                            expression: "username"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "email",
                          readonly: "",
                          id: "emailInput",
                          "aria-describedby": "emailHelp"
                        },
                        domProps: { value: _vm.username },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.username = $event.target.value
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "emailInput" } }, [
                        _vm._v("Nova senha")
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.password,
                            expression: "password"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "password",
                          id: "passwordInput",
                          "aria-describedby": "passwordHelp",
                          placeholder: "Digite uma nova senha"
                        },
                        domProps: { value: _vm.password },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.password = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "small",
                        {
                          staticClass: "form-text text-muted",
                          attrs: { id: "passwordHelp" }
                        },
                        [
                          _vm._v(
                            "Senha com no mínimo 6 dígitos, e uma letra maiúscula, uma minúscula e um número."
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "emailInput" } }, [
                        _vm._v("Confirmar nova senha")
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.confirmPassword,
                            expression: "confirmPassword"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "password",
                          id: "confirmPasswordInput",
                          "aria-describedby": "passwordHelp",
                          placeholder: "Confirme a nova senha"
                        },
                        domProps: { value: _vm.confirmPassword },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.confirmPassword = $event.target.value
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn",
                        attrs: { type: "submit" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _vm.redefinePassword()
                          }
                        }
                      },
                      [_vm._v("Confirmar")]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.invalidToken
                ? _c("div", [
                    _c(
                      "span",
                      [
                        _vm._v("Token inválido. Clique "),
                        _c(
                          "router-link",
                          { attrs: { to: "/forgot-password" } },
                          [_vm._v("aqui")]
                        ),
                        _vm._v(" para redefinir a senha novamente.")
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.passwordRedefined
                ? _c("div", [
                    _c(
                      "span",
                      [
                        _vm._v("Clique "),
                        _c("router-link", { attrs: { to: "/login" } }, [
                          _vm._v("aqui")
                        ]),
                        _vm._v(" para entrar.")
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("Footer"),
      _vm._v(" "),
      _vm.loading ? _c("Loading") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-52991bce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52991bce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RedefinePassword.vue
// module id = null
// module chunks = 